const NoAuthLayout = ({
    children
}) => {
    return <>
        {children}
    </>
}

export default NoAuthLayout;